import React, {useState,useEffect, Fragment} from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { RichTextEditor } from '@mantine/rte';
import { api, rules,sportlist } from "../../apis/urls";
import axios from "axios";
import RteComponent from "./rulesRTE";
import { DatePicker } from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { decode } from "html-entities";

const EditRules =()=> {

    useEffect( ()=>{
        setLoader(true)
        sportsListing();
        Listing();
    },[])



    const { id } = useParams();

	let navigate = useNavigate();
	const RoutToList = () =>{
        navigate("/rules")
    }

    

    const initialValue ='<p></p>';


    const [result,setResult] = useState([]);
    const [sportsresult,setSportsResult] = useState([]);
    const [loader,setLoader] = useState(false);

    const [imgLoad, setImgLoad] = useState(false)

    const [name,setName] = useState('');
    const [sports,setSports] = useState('');
    // const [amount,setAmount] = useState('');
    const [instructions,setInstructions] = useState(null);
    const [marks,setMarks] = useState('');
    const [status,setStatus] = useState('');
    const [image,setImage] = useState('');
    const [fileSelect, setFileSelect] = useState('');
    const [test_lastDate,setTest_lastDate] = useState('');



    const [nameerror,setNameerror] = useState(false);
    const [sportserror,setSportserror] = useState(false);
    //const [amounterror,setAmounterror] = useState(false);
    const [minmarkerror,setMinmarkerror] = useState(false);
    const [statuserror,setStatuserror] = useState(false);


    const instructionset = (text) =>{
        //console.log(text)
        setInstructions(text)
    }
    

    const sportsListing = ()=>{

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: sportlist+'?page='+0+'&size='+200,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setSportsResult(response.data.data.items);
            
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });


    }


    const Listing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: rules+"/"+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            setResult(response.data.data);
            setSports(response.data.data.sports_id)
            // setAmount(response.data.data.amount)
            setInstructions(response.data.data.instructions)
            setMarks(response.data.data.min_mark)
            setStatus(response.data.data.status)
            setName(response.data.data.rule_name)
            setImage(response.data.data.image)
            setTest_lastDate(response.data.data.test_lastDate)

            if(response.data.data.image){
                setFileSelect((response.data.data.image).split("/")[3])
            }

            setLoader(false)
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });

    }


    const OnFormClick = () => {
        let error = 0;

        if(name === '')
        {
            setNameerror(true)
            error =1;
        }
        if(sports === '')
        {
            setSportserror(true)
            error = 1;
            
        }
        // if(amount === '')
        // {
        //     setAmounterror(true)
        //     error = 1;
            
        // }
        if(marks === '')
        {
            setMinmarkerror(true)
            error = 1;
            
        }
        if(status === '')
        {
            setStatuserror(true)
            error = 1;
            
        }
       
        let token = "Bearer "+localStorage.getItem('token');
        console.log(token)
        const data = {
            name :decode(name),
            sport_id :sports,
            //amount:amount,
            instructions:decode(instructions),
            min_mark:marks,
            image:image,
            test_lastDate:test_lastDate
        }
        console.log('all datas',data)
        const instance = axios.create({

            baseURL: rules+"/"+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.put('',data).then((response) =>{

            console.log("res data",response.data)
            
            let path = 'newPath'; 
            navigate("/rules")
           
          }).catch((error) =>{
            
            //console.log('error',error.message)

            //setNameerror('Enter the Name')
            

          });
    }



    const  changeHandler=(event)=>{
  
        setFileSelect(event.name)
        setImgLoad(true)

        let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('file', event)

        const instance = axios.create({
            baseURL: api+ 'workshopImage/upload',
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });


        instance.post('', data).then((response) =>{

            console.log("respooonse", response.data)
            setImage(response.data.Location)
            setImgLoad(false)

        }).catch((error) =>{     
            setImgLoad(false)
            console.log('error',error.message)  
        });

    }

 
    return(<>

    <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    

                <div className="page-title-wrpr">
                    <div className="page-title-left-column">
                        
                        <h2 className="page-title">Edit Test</h2>
                    </div>
                    <div className="page-rightside-action-column">
                        
                        
                    </div>
                
                
                </div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item"><Link to="/rules">Rules Tests</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Edit Test</li>
                    </ol>
                </nav>

                <div className="form-wrpr">
                    <div className="card formcard small">
                        <div className="card-body">
                            <div className="form-group">
                                <label className="degreehead">Name <span style={{color: "red"}}>*</span></label>
                                <input type="text" defaultValue={decode(result.rule_name)} onChange={e => {setName(e.target.value)}} className="form-control bg-dark dark-theme showtext"
                                placeholder="Enter Name" id="name"></input>
                                {
                                nameerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter Name</div>
                                :null
                                }
                            </div>
                            <div className="form-group">
                                <label className="degreehead">Sports <span style={{color: "red"}}>*</span></label>
                                <select onChange={e => {setSports(e.target.value)}} className="form-control bg-dark dark-theme showtext" id="status-selector">
                                    <option value="0">Select Sports</option>
                                    {sportsresult?.map((item,index)=> (
                                        <Fragment>
                                        {item.status === 'ACTIVE'?
                                            <option selected={item.id === sports?true:false} value={item.id} key={index}>{item.name}</option>:null
                                        }
                                        </Fragment>
                                    ))}
                                    
                                    
                                </select>
                                {
                                sportserror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select sports</div>
                                :null
                            }
                            </div>
                            { /*
                            <div className="form-group">
                                <label className="degreehead">Charge <span style={{color: "red"}}>*</span></label>
                                <input type="number" defaultValue={result.amount} onChange={e => {setAmount(e.target.value)}} className="form-control bg-dark dark-theme showtext"  placeholder="Enter ChargeA" id="name"></input>
                                {
                                amounterror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter Charge</div>
                                :null
                            }
                        </div> */ }

                            <div className="form-group">
                                {/* <label className="degreehead">Instructions</label> */}
                                {/* <RteComponent setinstructions={setInstructions} instruction={result.instructions} />     */}
                                <RteComponent setdescription={setInstructions} description={result.instructions} />     
                        
                            </div>
                   
                            <div className="form-group">
                                <label className="degreehead">Pass %<span style={{color: "red"}}>*</span></label>
                                
                                <input type="number" defaultValue={result.min_mark} onChange={e => {setMarks(e.target.value)}} className="form-control bg-dark dark-theme showtext" placeholder="Enter Minimum Mark" id="name"></input>
                                {
                                minmarkerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter Minimum mark</div>
                                :null
                            }
                            </div>


                            <div className="form-group">
                                <label className="degreehead">Last Date<span style={{color: "red"}}>*</span></label>
                                <DatePicker
                                    // defaultValue={dayjs('2015-01-01', "YYYY-MM-DD")}
                                    onChange={(date) => {
                                    setTest_lastDate(date);
                                    }}
                                    style={{width:'100%', background:'#e6e8eaab', height:"45px"}}
                                    className="form-controls" size="lg"  
                                    placeholder={test_lastDate?moment(test_lastDate).format("MM-DD-YYYY"):"Deadline Date (MM-DD-YYYY)"} 
                                    />                        
                            </div>





                            <div className="form-group">
                                <label className="degreehead">Upload image</label>
	
                                <div>
                                    <div class='file-input file-conferecne' style={{background:"#e6e8eaab", width:'100%'}}>
                                    <input type='file' onChange={(event)=>{changeHandler(event.target.files[0]);}} />	
                                        {image?
                                            <img src={image} width="20%" />:
                                            <span span class='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>Choose</span>
                                        }
                                    <span class='labels' style={{color:image?'dodgerblue':'gray', fontWeight:'500', fontSize:'12px', paddingLeft:image?'10px':null }} data-js-label>{!image?"No file selected":fileSelect}</span>
                                    </div>
                                </div>
							</div>

                            <div className="form-group text-right">
                                <button onClick={RoutToList} className="btn btn-danger btn-gisa" type="submit">Cancel</button>
                                <button 
                                 disabled={imgLoad?true:false}
                                onClick={OnFormClick} 
                                className="btn btn-primary btn-gisa" type="button">Update</button>
                            </div>


                        </div>
                    </div>
                </div>


                </div>
            </aside>
        </div>

    </>)
}

export default EditRules